var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
Object.defineProperty(exports, "queryClient", {
  enumerable: true,
  get: function get() {
    return _queryClient.queryClient;
  }
});
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native");
var _navigation = require("./src/navigation");
var _AppNavigator = _interopRequireDefault(require("./src/navigation/AppNavigator"));
var _LoadingSpinner = _interopRequireDefault(require("./src/components/LoadingSpinner"));
var _reactQuery = require("react-query");
var _asyncStorage = _interopRequireDefault(require("@react-native-async-storage/async-storage"));
var _types = require("./src/@types");
var _reactRedux = require("react-redux");
var _people = require("./src/api/people");
var _flashMessage = require("./src/service/flashMessage");
var _isWeb = _interopRequireDefault(require("./src/utils/isWeb"));
var _notistack = require("notistack");
var Sentry = _interopRequireWildcard(require("@sentry/react-native"));
var _store = require("./src/redux/store");
var _react2 = require("redux-persist/integration/react");
var _reducer = require("./src/modules/Auth/reducer");
var _unitsReducer = require("./src/modules/Units/unitsReducer");
var _versionReducer = require("./src/redux/reducers/versionReducer");
var _queryClient = require("./src/config/queryClient");
var _reportError = require("./src/utils/reportError");
var _appBootstrap = require("./src/utils/appBootstrap");
var _sentry = require("./src/service/sentry");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var COLD_START_THRESHOLD = 5 * 60 * 1000;
function getActiveRouteName(state) {
  if (!(state != null && state.routes)) return null;
  var route = state.routes[state.index];
  return route.state ? getActiveRouteName(route.state) : route.name;
}
function reportBootstrapError(error, action) {
  var extra = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return (0, _reportError.reportError)(error, {
    feature: 'app-bootstrap',
    action: action,
    extra: extra
  });
}
function restoreUnitsFromCache() {
  return _restoreUnitsFromCache.apply(this, arguments);
}
function _restoreUnitsFromCache() {
  _restoreUnitsFromCache = (0, _asyncToGenerator2.default)(function* () {
    try {
      var _cached$unitLinks;
      var unitsCache = yield _asyncStorage.default.getItem(_types.E_STORAGE_KEYS.UNITS_CACHE);
      if (!unitsCache) {
        return;
      }
      var _parseStoredJson3 = (0, _appBootstrap.parseStoredJson)(unitsCache, null),
        cached = _parseStoredJson3.value,
        cacheParseError = _parseStoredJson3.error;
      if (cacheParseError) {
        reportBootstrapError(cacheParseError, 'parse units cache', {
          storageKey: _types.E_STORAGE_KEYS.UNITS_CACHE
        });
        return;
      }
      if (cached != null && (_cached$unitLinks = cached.unitLinks) != null && _cached$unitLinks.length) {
        _store.store.dispatch({
          type: _unitsReducer.UNITS_SUCCESS,
          payload: cached.unitLinks
        });
        var defaultUnit = cached.unitLinks.find(function (unit) {
          return unit.isDefault === true;
        });
        if (defaultUnit) {
          _store.store.dispatch({
            type: _unitsReducer.UNITS_SET_DEFAULT,
            payload: defaultUnit.id
          });
        } else {
          var savedDefaultId = yield _asyncStorage.default.getItem(_types.E_STORAGE_KEYS.DEFAULT_UNIT_ID);
          var defaultId = (0, _appBootstrap.parseStoredStringValue)(savedDefaultId);
          if (defaultId) {
            _store.store.dispatch({
              type: _unitsReducer.UNITS_SET_DEFAULT,
              payload: defaultId
            });
          }
        }
      }
    } catch (error) {
      reportBootstrapError(error, 'restore units cache');
    }
  });
  return _restoreUnitsFromCache.apply(this, arguments);
}
function handleTokenRefresh() {
  return _handleTokenRefresh.apply(this, arguments);
}
function _handleTokenRefresh() {
  _handleTokenRefresh = (0, _asyncToGenerator2.default)(function* () {
    try {
      var _yield$getNewToken = yield (0, _people.getNewToken)(),
        token = _yield$getNewToken.token,
        refreshToken = _yield$getNewToken.refreshToken;
      _store.store.dispatch({
        type: _reducer.AUTH_SET_TOKEN,
        token: {
          token: token,
          refreshToken: refreshToken
        }
      });
      Sentry.captureMessage("Token renewed");
    } catch (error) {
      var normalizedError = (0, _reportError.reportError)(error, {
        feature: 'auth',
        action: 'refresh token',
        fallbackMessage: 'Token refresh failed'
      });
      (0, _flashMessage.showInformationMessage)('Token refresh failed, please login');
      yield _asyncStorage.default.removeItem(_types.E_STORAGE_KEYS.TOKEN_PERSIST);
      throw normalizedError;
    }
  });
  return _handleTokenRefresh.apply(this, arguments);
}
function detectColdStart() {
  return _detectColdStart.apply(this, arguments);
}
function _detectColdStart() {
  _detectColdStart = (0, _asyncToGenerator2.default)(function* () {
    var lastSessionTimestamp = yield _asyncStorage.default.getItem(_types.E_STORAGE_KEYS.LAST_SESSION_TIMESTAMP);
    var now = Date.now();
    var lastSessionMs = Number(lastSessionTimestamp);
    var isAppColdStart = !lastSessionTimestamp || !Number.isFinite(lastSessionMs) || now - lastSessionMs > COLD_START_THRESHOLD;
    yield _asyncStorage.default.setItem(_types.E_STORAGE_KEYS.LAST_SESSION_TIMESTAMP, now.toString());
    return isAppColdStart;
  });
  return _detectColdStart.apply(this, arguments);
}
var Application = function Application() {
  var _React$useState = _react.default.useState(false),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    isReady = _React$useState2[0],
    setIsReady = _React$useState2[1];
  var _React$useState3 = _react.default.useState(),
    _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
    initialState = _React$useState4[0],
    setInitialState = _React$useState4[1];
  var _React$useState5 = _react.default.useState(false),
    _React$useState6 = (0, _slicedToArray2.default)(_React$useState5, 2),
    isColdStart = _React$useState6[0],
    setIsColdStart = _React$useState6[1];
  var _React$useState7 = _react.default.useState(false),
    _React$useState8 = (0, _slicedToArray2.default)(_React$useState7, 2),
    refreshingToken = _React$useState8[0],
    setRefreshingToken = _React$useState8[1];
  var dispatch = (0, _reactRedux.useDispatch)();
  var versionState = (0, _reactRedux.useSelector)(function (state) {
    return state == null ? void 0 : state.version;
  });
  var currentUser = (0, _reactRedux.useSelector)(function (state) {
    var _state$auth;
    return state == null ? void 0 : (_state$auth = state.auth) == null ? void 0 : _state$auth.user;
  });
  var currentUnitId = (0, _reactRedux.useSelector)(function (state) {
    var _state$units$unitLink, _state$units, _state$units$unitLink2, _state$units$unitLink3;
    return (_state$units$unitLink = state == null ? void 0 : (_state$units = state.units) == null ? void 0 : (_state$units$unitLink2 = _state$units.unitLinks) == null ? void 0 : (_state$units$unitLink3 = _state$units$unitLink2.find(function (link) {
      return link.isDefault === true;
    })) == null ? void 0 : _state$units$unitLink3.id) != null ? _state$units$unitLink : null;
  });
  (0, _react.useEffect)(function () {
    (0, _sentry.setSentryUserContext)(currentUser != null ? currentUser : null);
    (0, _sentry.setSentryUnitContext)(currentUnitId);
  }, [currentUnitId, currentUser == null ? void 0 : currentUser.email, currentUser == null ? void 0 : currentUser.id, currentUser == null ? void 0 : currentUser.username]);
  function restoreState() {
    return _restoreState.apply(this, arguments);
  }
  function _restoreState() {
    _restoreState = (0, _asyncToGenerator2.default)(function* () {
      try {
        var _navigationState$rout;
        var isAppColdStart = yield detectColdStart();
        setIsColdStart(isAppColdStart);
        var savedStateString = yield _asyncStorage.default.getItem(_types.E_STORAGE_KEYS.NAVIGATION_PERSIST);
        var _parseStoredJson = (0, _appBootstrap.parseStoredJson)(savedStateString, undefined),
          navigationState = _parseStoredJson.value,
          navigationStateParseError = _parseStoredJson.error;
        if (navigationStateParseError) {
          reportBootstrapError(navigationStateParseError, 'parse navigation state', {
            storageKey: _types.E_STORAGE_KEYS.NAVIGATION_PERSIST
          });
        }
        var savedUserString = yield _asyncStorage.default.getItem(_types.E_STORAGE_KEYS.USER);
        var _parseStoredJson2 = (0, _appBootstrap.parseStoredJson)(savedUserString, undefined),
          user = _parseStoredJson2.value,
          userParseError = _parseStoredJson2.error;
        if (userParseError) {
          reportBootstrapError(userParseError, 'parse persisted user', {
            storageKey: _types.E_STORAGE_KEYS.USER
          });
        }
        if (user) {
          _store.store.dispatch({
            type: _reducer.AUTH_SIGN_IN_SUCCESS,
            user: user
          });
        }
        if (navigationState && !isAppColdStart) {
          setInitialState(navigationState);
        }
        var persistedState = yield _asyncStorage.default.getItem(_types.E_STORAGE_KEYS.REDUX_PERSIST_ROOT);
        if (!persistedState) {
          yield restoreUnitsFromCache();
        }
        var tokenString = yield _asyncStorage.default.getItem(_types.E_STORAGE_KEYS.AUTH_TOKEN);
        var tokenState = (0, _appBootstrap.getPersistedTokenState)(tokenString);
        var isRegistrationFlow = navigationState == null ? void 0 : (_navigationState$rout = navigationState.routeNames) == null ? void 0 : _navigationState$rout.includes('Dl Capture');
        if (tokenState.status === 'expired') {
          setRefreshingToken(true);
          try {
            yield handleTokenRefresh();
          } catch (_unused) {
            dispatch({
              type: _types.E_STORAGE_KEYS.CLEAR_REDUX_PERSIST_ROOT
            });
          } finally {
            setRefreshingToken(false);
          }
        } else if (tokenState.status === 'valid') {
          _store.store.dispatch({
            type: _reducer.AUTH_SET_TOKEN,
            token: {
              token: tokenState.token,
              refreshToken: tokenState.refreshToken
            }
          });
        } else if (tokenState.status === 'invalid') {
          (0, _reportError.reportError)(tokenState.error, {
            feature: 'auth',
            action: 'parse persisted token',
            extra: {
              isRegistrationFlow: isRegistrationFlow
            }
          });
          yield _asyncStorage.default.removeItem(_types.E_STORAGE_KEYS.AUTH_TOKEN);
          if (!isRegistrationFlow) {
            (0, _flashMessage.showInformationMessage)('Signing you out, please login to continue');
            yield _asyncStorage.default.removeItem(_types.E_STORAGE_KEYS.TOKEN_PERSIST);
            dispatch({
              type: _types.E_STORAGE_KEYS.CLEAR_REDUX_PERSIST_ROOT
            });
          }
        } else {
          if (!isRegistrationFlow) {
            (0, _flashMessage.showInformationMessage)('Signing you out, please login to continue');
            yield _asyncStorage.default.removeItem(_types.E_STORAGE_KEYS.TOKEN_PERSIST);
            dispatch({
              type: _types.E_STORAGE_KEYS.CLEAR_REDUX_PERSIST_ROOT
            });
          }
        }
        if (!_isWeb.default) {
          void dispatch((0, _versionReducer.checkAppVersionThunk)()).catch(function (versionError) {
            (0, _reportError.reportError)(versionError, {
              feature: 'version-check',
              action: 'bootstrap version check'
            });
          });
        }
      } catch (error) {
        reportBootstrapError(error, 'restore persisted state');
      } finally {
        if (_isWeb.default) {
          var spinner = document.getElementById('loading-spinner');
          if (spinner) spinner.style.display = 'none';
        }
        setIsReady(true);
      }
    });
    return _restoreState.apply(this, arguments);
  }
  (0, _react.useEffect)(function () {
    if (!isReady) {
      void restoreState();
    }
  }, [isReady]);
  (0, _react.useEffect)(function () {
    if (versionState != null && versionState.isUpdateRequired && !_isWeb.default) {
      var APP_STORE_URL = 'https://apps.apple.com/us/app/asterix-community-app/id6446774852';
      var PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=info.onlinemanagement.community';
      _reactNative.Alert.alert('Update Required', versionState.updateMessage || 'A new version of the app is available. Please update to continue using the app.', [{
        text: 'Update Now',
        onPress: function onPress() {
          var url = _reactNative.Platform.OS === 'ios' ? APP_STORE_URL : PLAY_STORE_URL;
          _reactNative.Linking.openURL(url);
        }
      }], {
        cancelable: false
      });
    }
  }, [versionState == null ? void 0 : versionState.isUpdateRequired, versionState == null ? void 0 : versionState.updateMessage]);
  if (!isReady) {
    return (0, _jsxRuntime.jsx)(_LoadingSpinner.default, {});
  }
  return (0, _jsxRuntime.jsx)(_reactQuery.QueryClientProvider, {
    client: _queryClient.queryClient,
    children: (0, _jsxRuntime.jsxs)(_react2.PersistGate, {
      loading: (0, _jsxRuntime.jsx)(_LoadingSpinner.default, {}),
      persistor: _store.persistor,
      children: [_isWeb.default && (0, _jsxRuntime.jsx)(_notistack.SnackbarProvider, {}), (0, _jsxRuntime.jsx)(_AppNavigator.default, {
        navigationRef: _navigation.navigationRef,
        initialState: initialState,
        onStateChange: function onStateChange(state) {
          var activeRoute = getActiveRouteName(state);
          (0, _sentry.setSentryRouteContext)(activeRoute);
          if (activeRoute === _types.E_NAVIGATION_DESTINATIONS.NOTIFICATION_DETAILS) {
            return;
          }
          _asyncStorage.default.setItem(_types.E_STORAGE_KEYS.NAVIGATION_PERSIST, JSON.stringify(state));
        }
      })]
    })
  });
};
var _default = exports.default = Application;